import { Globe } from "@/components/Globe";

const WORDS = ["Housegemacht", "The Home of House", "Köln", "House Music", "Auf ungewöhnliche Floors"];

export const Marquee = () => (
  <section className="overflow-hidden border-y-2 border-[#f4f4f2] py-4 md:py-5" data-testid="marquee-section" aria-hidden="true">
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center">
          {WORDS.map((w, i) => (
            <span key={i} className="flex items-center gap-6 px-6 md:gap-10 md:px-10">
              <span className="font-display text-xl uppercase tracking-tight md:text-3xl">{w}</span>
              <Globe className="h-5 w-5 text-[#a8a8a4] md:h-7 md:w-7" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
